module.exports = __webpack_public_path__ + "img/17.97f84de9.jpg";